/*
An SDK Factory for NW Data APIs

See https://nerdwallet.atlassian.net/wiki/spaces/ENG/pages/164987345/Working+Data+API+Spec
for Data API details.
*/
import serviceHTTPHelper from './service-http-helper';

function dataApiEndpoint(entityName, identityID, entityID) {
  var identityPart = identityID && "identities/".concat(identityID);
  var url = [identityPart, entityName, entityID].filter(Boolean).join('/');
  return "/".concat(url);
}

export default function (ServiceSDK, routeBuilder) {
  var service = serviceHTTPHelper(ServiceSDK, routeBuilder);
  return {
    getSingularIdentityEntityAPI: function getSingularIdentityEntityAPI(entityName) {
      return {
        // Access to my own data.
        getMy: function getMy(params, serverRequest) {
          var endpoint = dataApiEndpoint(entityName, 'me', null);
          return service.get(endpoint, params, serverRequest);
        },
        postMy: function postMy(entityData, serverRequest) {
          var endpoint = dataApiEndpoint(entityName, 'me', null);
          return service.post(endpoint, entityData, serverRequest);
        },
        putMy: function putMy(entityData, serverRequest) {
          var endpoint = dataApiEndpoint(entityName, 'me', null);
          return service.put(endpoint, entityData, serverRequest);
        },
        patchMy: function patchMy(dirtyEntityData, serverRequest) {
          var endpoint = dataApiEndpoint(entityName, 'me', null);
          return service.patch(endpoint, dirtyEntityData, serverRequest);
        },
        deleteMy: function deleteMy(serverRequest) {
          var endpoint = dataApiEndpoint(entityName, 'me', null);
          return service.delete(endpoint, {}, serverRequest);
        },
        // Access to someone else's data.
        get: function get(identityID, params, serverRequest) {
          var endpoint = dataApiEndpoint(entityName, identityID, null);
          return service.get(endpoint, params, serverRequest);
        },
        post: function post(identityID, entityData, serverRequest) {
          var endpoint = dataApiEndpoint(entityName, identityID, null);
          return service.post(endpoint, entityData, serverRequest);
        },
        put: function put(identityID, entityData, serverRequest) {
          var endpoint = dataApiEndpoint(entityName, identityID, null);
          return service.put(endpoint, entityData, serverRequest);
        },
        patch: function patch(identityID, dirtyEntityData, serverRequest) {
          var endpoint = dataApiEndpoint(entityName, identityID, null);
          return service.patch(endpoint, dirtyEntityData, serverRequest);
        },
        delete: function _delete(identityID, serverRequest) {
          var endpoint = dataApiEndpoint(entityName, identityID, null);
          return service.delete(endpoint, {}, serverRequest);
        }
      };
    },
    getPluralIdentityEntityAPI: function getPluralIdentityEntityAPI(entityName) {
      return {
        // Access to my own data.
        getAllMy: function getAllMy(params, serverRequest) {
          var endpoint = dataApiEndpoint(entityName, 'me', null);
          return service.get(endpoint, params, serverRequest);
        },
        getMy: function getMy(entityID, params, serverRequest) {
          var endpoint = dataApiEndpoint(entityName, 'me', entityID);
          return service.get(endpoint, params, serverRequest);
        },
        postMy: function postMy(entityData, serverRequest) {
          var endpoint = dataApiEndpoint(entityName, 'me', null);
          return service.post(endpoint, entityData, serverRequest);
        },
        putMy: function putMy(entityID, entityData, serverRequest) {
          var endpoint = dataApiEndpoint(entityName, 'me', entityID);
          return service.put(endpoint, entityData, serverRequest);
        },
        patchMy: function patchMy(entityID, dirtyEntityData, serverRequest) {
          var endpoint = dataApiEndpoint(entityName, 'me', entityID);
          return service.patch(endpoint, dirtyEntityData, serverRequest);
        },
        deleteMy: function deleteMy(entityID, serverRequest) {
          var endpoint = dataApiEndpoint(entityName, 'me', entityID);
          return service.delete(endpoint, {}, serverRequest);
        },
        // Access to someone else's data.
        getAll: function getAll(identityID, params, serverRequest) {
          var endpoint = dataApiEndpoint(entityName, identityID, null);
          return service.get(endpoint, params, serverRequest);
        },
        get: function get(identityID, entityID, params, serverRequest) {
          var endpoint = dataApiEndpoint(entityName, identityID, entityID);
          return service.get(endpoint, params, serverRequest);
        },
        post: function post(identityID, entityData, serverRequest) {
          var endpoint = dataApiEndpoint(entityName, identityID, null);
          return service.post(endpoint, entityData, serverRequest);
        },
        put: function put(identityID, entityID, entityData, serverRequest) {
          var endpoint = dataApiEndpoint(entityName, identityID, entityID);
          return service.put(endpoint, entityData, serverRequest);
        },
        patch: function patch(identityID, entityID, dirtyEntityData, serverRequest) {
          var endpoint = dataApiEndpoint(entityName, identityID, entityID);
          return service.patch(endpoint, dirtyEntityData, serverRequest);
        },
        delete: function _delete(identityID, entityID, serverRequest) {
          var endpoint = dataApiEndpoint(entityName, identityID, entityID);
          return service.delete(endpoint, {}, serverRequest);
        }
      };
    },
    getPluralEntityAPI: function getPluralEntityAPI(entityName) {
      // Access to data.
      return {
        getAll: function getAll(params, serverRequest) {
          var endpoint = dataApiEndpoint(entityName, null, null);
          return service.get(endpoint, params, serverRequest);
        },
        get: function get(entityID, params, serverRequest) {
          var endpoint = dataApiEndpoint(entityName, null, entityID);
          return service.get(endpoint, params, serverRequest);
        },
        post: function post(entityData, serverRequest) {
          var endpoint = dataApiEndpoint(entityName, null, null);
          return service.post(endpoint, entityData, serverRequest);
        },
        put: function put(entityID, entityData, serverRequest) {
          var endpoint = dataApiEndpoint(entityName, null, entityID);
          return service.put(endpoint, entityData, serverRequest);
        },
        patch: function patch(entityID, dirtyEntityData, serverRequest) {
          var endpoint = dataApiEndpoint(entityName, null, entityID);
          return service.patch(endpoint, dirtyEntityData, serverRequest);
        },
        delete: function _delete(entityID, serverRequest) {
          var endpoint = dataApiEndpoint(entityName, null, entityID);
          return service.delete(endpoint, {}, serverRequest);
        }
      };
    }
  };
}